import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/src/app/[locale]/(main)/auth/_components/login-form.tsx");
